import React from 'react'
import { withRouter, Switch, Route } from 'react-router-dom'
import CompetitionsView from './CompetitionsView'
import NewCompetitionView from './NewCompetitionView'
import NewDivisionView from './NewDivisionView'
import NewEventView from './NewEventView'
import DivisionView from './DivisionView'
import AddDivisionTeamView from './AddDivisionTeamView'

const CompetitionsApp = ({ history }) => {

  return (
    <Switch>
      <Route exact path="/soccer/competitions">
        <CompetitionsView/>
      </Route>
      <Route exact path="/soccer/competitions/new">
        <NewCompetitionView/>
      </Route>
      <Route exact path="/soccer/competitions/divisions/new">
        <NewDivisionView/>
      </Route>
      <Route exact path="/soccer/competitions/divisions/:divisionId">
        <DivisionView/>
      </Route>
      <Route exact path="/soccer/competitions/divisions/:divisionId/teams/add">
        <AddDivisionTeamView/>
      </Route>
      <Route exact path="/soccer/competitions/events/new">
        <NewEventView/>
      </Route>
      <Route exact path="/soccer/competitions/:competitionId">
        <NewCompetitionView/>
      </Route>
    </Switch>
  )
}

export default withRouter(CompetitionsApp)